import { createSlice } from "@reduxjs/toolkit";
import { getAccountDetails, getProfile } from "./thunkActions";

export type AccountStatus = "idle" | "loading" | "ready" | "error";

interface InitialState {
  isLoading: boolean;
  isUpdatingPassword: boolean;
  isAccLoading: boolean;
  accountStatus: AccountStatus;
  twoFactorSetup: ITwoFactorSetup | null;
  profile: IProfile | null;
  accountDetails: IAccountDetails | null;
}

const initialState: InitialState = {
  isLoading: false,
  isAccLoading: false,
  accountStatus: "idle",
  twoFactorSetup: null,
  isUpdatingPassword: false,
  profile: null,
  accountDetails: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setTwoFactorSetup(state, action: { payload: ITwoFactorSetup | null }) {
      state.twoFactorSetup = action.payload;
      if (action.payload === null) {
        state.accountDetails = null;
        state.profile = null;
        state.accountStatus = "idle";
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.profile = null;
        state.isLoading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.isLoading = false;
      })
      .addCase(getProfile.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getAccountDetails.pending, (state) => {
        state.isAccLoading = true;
        state.accountStatus = "loading";
      })
      .addCase(getAccountDetails.fulfilled, (state, action) => {
        state.accountDetails = action.payload;
        state.twoFactorSetup = {
          two_factor_setup_required: action.payload.two_factor_setup_required,
          two_factor_deadline_at: action.payload.two_factor_deadline_at,
        };
        state.isAccLoading = false;
        state.accountStatus = "ready";
      })
      .addCase(getAccountDetails.rejected, (state) => {
        state.isAccLoading = false;
        state.accountStatus = state.accountDetails ? "ready" : "error";
      })
  },
});

export const { setTwoFactorSetup } = profileSlice.actions;
export default profileSlice.reducer;
export * from "./thunkActions";
